import { Loader, Section } from '@/components/shared';
import { useAppSelector } from '@/hooks';
import { scrollToTop } from '@/utils';
import { Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { StepDescription, StepForm } from '../components';

export const SummaryStep = (): JSX.Element => {
  const { t } = useTranslation();
  const isQuoteCreating = useAppSelector((state) => state.quote.creating);
  const hasQuoteError = useAppSelector((state) => state.quote.hasError);

  scrollToTop();

  if (isQuoteCreating) return <Loader />;

  return (
    <Section
      containerProps={{ py: 0 }}
      headingProps={{ mt: 0 }}
      id="summary-section"
      title={t('WIZARD.SUMMARY.STEP_TITLE')}
    >
      <Flex
        alignItems={{ base: 'center', md: 'flex-start' }}
        direction={{ base: 'column', md: 'row' }}
        gap={12}
        justifyContent="center"
        w="full"
      >
        <StepDescription hasError={hasQuoteError} />
        <StepForm />
      </Flex>
    </Section>
  );
};
